import { Fragment, useEffect } from 'react'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import usePopupStore from '../../../store/usePopupStore'
import { Popup } from '../../basic/Popup'
import { AlertPopup } from '../../basic/popup/AlertPopup'
import { BasicPopup } from '../../basic/popup/BasicPopup'
import { SidePopup } from '../../basic/popup/SidePopup'
import { SplitPopup } from '../../basic/popup/SplitPopup'
import { TranslatorSidePopup } from '../../new-portal/materials/QuestionSelect/TranslatorSidePopup'
import { CafSidePopup } from '../../webview/caf/common/CafSidePopup'
import { WebviewModal } from '../../webview/caf/common/Modal/WebviewModal'
import { BottomSheet } from './BottomSheet'
import { ConfirmPopup } from './ConfirmPopup'

const PopupProvider = () => {
  const router = useAppRouter()

  const popupCloseAll = usePopupStore((state) => state.closeAll)
  const popups = usePopupStore((state) => state.data)

  useEffect(() => {
    return () => {
      popupCloseAll()
    }
  }, [router.asPath])

  return (
    <Fragment>
      {Object.keys(popups)
        .map((key) => popups[key])
        .map((item, idx) => {
          if (item?.type == 'confirm') return <ConfirmPopup key={idx} id={item.id} />
          if (item?.type == 'split') return <SplitPopup key={idx} id={item.id} />
          if (item?.type == 'popup') return <Popup key={idx} id={item.id} />
          if (item?.type == 'side') return <SidePopup key={idx} id={item.id} />
          if (item?.type == 'cafSide') return <CafSidePopup key={idx} id={item.id} />
          if (item?.type == 'basic') return <BasicPopup key={idx} id={item.id} />
          if (item?.type == 'alert') return <AlertPopup key={idx} id={item.id} />
          if (item?.type == 'translatorSide') return <TranslatorSidePopup key={idx} id={item.id} />
          if (item?.type == 'bottom-sheet') return <BottomSheet key={idx} id={item.id} />
          if (item?.type.startsWith('webview')) return <WebviewModal key={idx} id={item.id} />
        })}
    </Fragment>
  )
}

export default PopupProvider
